import WidgetModel from '../widget-model'
import DatasetTableWidgetView from './dataset-table-widget-view'
import _ from 'lodash'
import DatasetTable from 'scoreboard/datasets/model/dataset-table'
import wrapModel from 'scoreboard/components/wrap-model'
import DataSourceWidgetModel from '../data-source-widget-model'
import Backbone from 'backbone'
import { DATASETS } from 'scoreboard/components/sections'

var DatasetTableWidget = DataSourceWidgetModel.extend({
	containerDefaults: {
		width: 480,
		height: 330
	},

	viewCls: DatasetTableWidgetView,

	multiSettableProps: [ 'background', 'fontSize', 'tablePadding' ],

	section () {
		return _.isNil(this.datasetId()) ? null : DATASETS
	},

	initialize: function(attr, options = {}) {
		WidgetModel.prototype.initialize.apply(this, arguments)
		const tableId = this.get('properties')?.datasetTableId
		this.table = this.get('table')
		const optionTable =
			// New widgets will have the table in the constructor options
			// (not the attributes)
			options.table
			// Widgets that haven't been saved yet but have been loaded from
			// a server data fetch (like in forms) will have the table in the
			// wob attributes.
			// #58501 Forms will also have the table here if they have been
			// changed but the changes haven't been saved yet
			?? attr.wob?.table
			// Persisted tables will have a datasetTableId, and the table will
			// be in the dashboard data
			?? this.data.tablesById(tableId)
		if (!_.isEmpty(optionTable)) {
			this.table = wrapModel(optionTable, DatasetTable)
		}
		this.table?.set('filters', this.filters() ?? [])
	},

	setDataSource ({ domainType, dataSource, period }) {
		if (_.isNil(domainType)) {
			this.properties.unset('datasetId')
			this.properties.unset('filters')
			this.table.clear()
		} else {
			this.maybeClearAggregations(dataSource)
			this.properties.set('datasetId', dataSource.datasetId)
			this.filters(dataSource.filters)
			this.table.set(dataSource)
		}
	},

	/**
	 * After using the "Set Data Source" option, it may be necessary to clear
	 * the columns in the table (called "aggregations" in the code).
	 * For ease of implementation, we clear them whenever the dataset ID
	 * changes. In the future we could be more discerning about when to clear
	 * them. For example, when switching to a linked dataset, it's possible
	 * there are equivalent VLFs which would allow the columns to be preserved.
	 *
	 * Note: The Set Data Source dialog takes care of clearing filters (if
	 * necessary) before this method is called.
	 */
	maybeClearAggregations (dataSource) {
		if (!dataSource) return // #58815
		let oldDatasetId = this.datasetId()
		let newDatasetId = dataSource.datasetId
		if (oldDatasetId != newDatasetId) {
			dataSource.aggregations = []
			dataSource.repeatingRowGrouping = undefined
			dataSource.repeatingColumnGrouping = undefined
		}
	},

	datasetId () {
		return this.properties.get('datasetId')
	},

	hasManualFilter () {
		let filters = this.filters() || []

		let aggFilters = _.flatMap(this.table.get('aggregations'), agg => {
			let filters = agg.filters || []
			return _.concat(filters, _.flatMap(agg.aggregations, subagg => subagg.filters || []))
		})

		filters = _.concat(filters, aggFilters)

		return !!filters && filters.length > 0
	},

	// gets or sets dataset filters property. Handles converting to/from JSON string
	// (which is how widget properties are stored in the database)
	filters: function (newFilters) {
		if (arguments.length === 0) {
			let filters = this.properties.get('filters')
			return filters ? JSON.parse(filters) : null
		}

		this.properties.set('filters', JSON.stringify(newFilters))
	},

	toJSON: function() {
		const widget = Backbone.Model.prototype.toJSON.apply(this, arguments)
		widget.table = _.cloneDeep(this.table)
		return widget
	}

})

export default DatasetTableWidget

DatasetTableWidget.__filename__ = 'dashboards/widgets/dataset-table/dataset-table-widget-model.js'
